import { createAsyncThunk } from "@reduxjs/toolkit";
import { SEND_OTP_AUTH, VERIFY_OTP_AUTH } from "../../../helpers/url_helper";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

/**
 * Send OTP to mobile number for signup/login
 */
export const sendOtpAuth = createAsyncThunk(
  "otpLogin/sendOtp",
  async (mobile, { rejectWithValue }) => {
    try {
      const response = await api.create(SEND_OTP_AUTH, { mobile });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Verify OTP and login/signup user
 */
export const verifyOtpAuth = createAsyncThunk(
  "otpLogin/verifyOtp",
  async ({ mobile, otp }, { rejectWithValue }) => {
    try {
      const response = await api.create(VERIFY_OTP_AUTH, { mobile, otp });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
